import { render, staticRenderFns } from "./CitasComponente.vue?vue&type=template&id=cf4b0700&"
import script from "./CitasComponente.vue?vue&type=script&lang=js&"
export * from "./CitasComponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports